import styled, { css } from 'styled-components';
import React from 'react';

export const CardProducElement = styled.div`
  ${({ theme, ...props }) => {
    return css`
      background: ${theme.color.primary_100};
      border-radius: ${theme.radius.sm};
      overflow: hidden;

      display: flex;
      flex-direction: column;
      box-shadow: ${theme.box_shadow.sm};
    `;
  }};
`;

export const CardProductImage = styled.div`
  ${({ theme, ...props }) => {
    return css`
      position: relative;
      width: 100%;
    `;
  }};
`;

export const BadgesContainer = styled.div`
  ${({ theme, ...props }) => {
    return css`
      position: absolute;
      top: 0.5rem;
      left: 0;
      width: 100%;
      padding: 0 0.5rem;
      > span {
        display: inline-block;
        box-shadow: ${theme.box_shadow.base};
      }
    `;
  }};
`;

export const CardProductDetail = styled.div`
  ${({ theme, ...props }) => {
    return css`
      padding: 1rem;
      min-height: 15rem;
    `;
  }};
`;

export const CardProductPriceCta = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      gap: 0.5rem;
      padding: 1rem;

      color: ${theme.color.white};
      background-color: ${theme.color.secondary_600};

      // PriceContainer
      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        sup {
          font-size: 0.75rem;
          top: -1rem;
        }
      }
    `;
  }};
`;
